/**
 * Phase 5.9 — Online indicator dot.
 * Pure presentation component: pass `online` boolean (truthy = green pulsing).
 */
import React from 'react';

export function OnlineDot({ online, size = 8, title, 'data-testid': testId }) {
  const color = online ? '#33FF57' : '#444';
  const shadow = online
    ? '0 0 6px rgba(51, 255, 87, 0.85), 0 0 12px rgba(51, 255, 87, 0.4)'
    : 'none';
  return (
    <span
      data-testid={testId || (online ? 'online-dot' : 'offline-dot')}
      title={title || (online ? 'Online' : 'Offline')}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        boxShadow: shadow,
        verticalAlign: 'middle',
        animation: online ? 'pulse-presence 1.6s ease-in-out infinite' : 'none',
      }}
    />
  );
}

// Inject the keyframes once at module load (no global CSS file edit needed).
if (typeof document !== 'undefined' && !document.getElementById('online-dot-keyframes')) {
  const style = document.createElement('style');
  style.id = 'online-dot-keyframes';
  style.textContent = `
    @keyframes pulse-presence {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.55; transform: scale(0.85); }
    }
  `;
  document.head.appendChild(style);
}
